/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RendicontazioneNegozioDTO { 
    id?: string;
    negozio_id?: string;
    negozio_nome?: string;
    importo_lordo?: number;
    importo_netto?: number;
    numero_transazioni?: number;
}

